import { AppActionSection } from "Components/AppActionSection";
import { Color } from "Components/Form/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  MilitaryOnlyHeader,
  MilitaryPermissionInfo,
  MilitaryReportDescription,
  MilitaryReportTitle,
} from "./styles";
import { ReportsTable } from "./MilitarySettingsPageReportTemplateTable";
import { Lock1 } from "iconsax-react";
import ReportsGroupsService from "Services/reports.groups.service";
import { useQuery } from "@tanstack/react-query";
import { CheckListKeys, ReportGroupKeys } from "Util/queries";
import { Skeleton } from "@mui/material";
import { useAppState } from "Context/StateContext";
import { Status } from "Util/enums";
import ChecklistService from "Services/checklist.service";

export const MilitarySettingsPage = () => {
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const { isFetching: isLoadingReports, data } = useQuery({
    queryKey: ReportGroupKeys.getAll([currentUser?.company.profileId]),
    queryFn: async () => {
      const response = await ReportsGroupsService.getAll({
        companyProfileId: currentUser?.company.profileId,
        group: "Operations",
        include: JSON.stringify([
          { association: "reports", include: [{ association: "reportGroup" }] },
        ]),
      });

      if (response && response.data) return response.data;
    },
    enabled: !!currentUser?.id && !!currentUser?.company.profileId,
    refetchOnWindowFocus: false,
    staleTime: 30 * 60 * 1000, // 30 minutes
  });

  const { isFetching: isLoadingChecklists, data: checklistsData } = useQuery({
    queryKey: CheckListKeys.getAll([Status.ACTIVE, currentUser?.companyId, "description", "desc"]),
    queryFn: async () =>
      ChecklistService.getAll({
        status: Status.ACTIVE,
        companyId: currentUser?.companyId,
        sortBy: JSON.stringify([["description", "desc"]]),
      }),
    enabled: !!currentUser?.companyId,
    refetchOnWindowFocus: false,
    staleTime: 30 * 60 * 1000, // 30 minutes
  });

  const renderContent = () => {
    if (isLoadingReports || isLoadingChecklists) {
      return (
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          {Array.from({ length: 4 }).map((_, index) => {
            return <Skeleton variant="rounded" height="40px" key={index} />;
          })}
        </div>
      );
    }

    return (
      <Container>
        <ReportsTable reports={data?.[0]?.reports} checklists={checklistsData?.data} />
      </Container>
    );
  };

  return (
    <div>
      <AppActionSection buttons={[]}>
        <MilitaryOnlyHeader>
          <MilitaryReportTitle>{translate("reportTemplates")}</MilitaryReportTitle>
        </MilitaryOnlyHeader>
        <MilitaryReportDescription>
          {translate("defineWhichTemplateEachReportUses")}
        </MilitaryReportDescription>
        {renderContent()}
        <MilitaryPermissionInfo>
          <Lock1 />
          <span>{translate("accessToThisSectionIsRestrictedByPermissionLevel")}</span>
        </MilitaryPermissionInfo>
      </AppActionSection>
    </div>
  );
};
